import { getViewportInnerHeight, getViewportInnerWidth } from "../../utils/Dom";
/**
 * isExitPosition
 * Exit position is:
 *  - mouse should at least be in top 20px of viewport
 *  - if mouse is in top right area, which is above 75% of width and below 25% of height,
 *    then it should be in top 5px of viewport
 */
export var isExitPosition = function (_a) {
    var x = _a.x, y = _a.y;
    if (y > 20) {
        return false;
    }
    var vpWidth = getViewportInnerWidth();
    var vpHeight = getViewportInnerHeight();
    var isInRightTop = x > vpWidth * 0.75 && y < vpHeight * 0.25;
    return isInRightTop ? y < 5 : true;
};
//# sourceMappingURL=Utils.js.map